import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { CoreMenuService } from '@core/components/core-menu/core-menu.service';
import { ethers } from 'ethers';
import { ToastService } from 'app/components/toasts/toasts.service';
import { AuthenticationService } from 'app/auth/service';
import { LoginComponent } from 'app/common/login/login.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';

declare let window: any;


@Component({
  selector: '[core-menu]',
  templateUrl: './core-menu.component.html',
  styleUrls: ['./core-menu.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CoreMenuComponent implements OnInit {

  private provider: ethers.providers.Web3Provider;
  private signer: ethers.providers.JsonRpcSigner;

  @Input()
  layout = 'vertical';

  @Input()
  menu: any;



  /**
   *
   * @param {ChangeDetectorRef} _changeDetectorRef
   * @param {CoreMenuService} _coreMenuService
   */
  constructor(
    private _changeDetectorRef: ChangeDetectorRef, 
    private _coreMenuService: CoreMenuService, 
    private toast:ToastService,
    private authService: AuthenticationService,
    public modalService: NgbModal,
    private _router: Router) {
  }

  // Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */
  ngOnInit(): void {
    // Set the menu either from the input or from the service
    this._coreMenuService.onMenuChanged.subscribe(() =>{
      this.menu = this.menu || this._coreMenuService.getCurrentMenu();
      // Load menu
      this.menu = this._coreMenuService.getCurrentMenu();
      this._changeDetectorRef.markForCheck();
    });
  }


  public checking(){
    this.toast.show('Please Select a Ticker', {
      delay: 2000,
      classname: 'bg-primary text-light',
      autohide: true
    });
  }

  public async clickable(item){
    if(item.id == 'myportfolio'){
      if(this.authService.currentUserValue){
        if(this.authService.currentUserValue.user){
          if(this.authService.currentUserValue.user.walletAddress != 'null'){
            this._router.navigate([item.url, this.authService.currentUserValue.user.walletAddress]);
          } else {
            this.toast.show('Please Update your wallet address', {
              delay: 3000,
              classname: 'bg-warning text-light',
              autohide: true
            });
          }
        } else {
          this.provider = new ethers.providers.Web3Provider(window.ethereum);
          this.signer = this.provider.getSigner();
          const address = await this.signer.getAddress();
          this._router.navigate([item.url, address])
        }
      } else {
        this.modalService.open(LoginComponent, {
          size: 'sm',
          centered: true
        });
      }
    }
  }
  
}
